module.exports = __webpack_public_path__ + "media/images/clock-2e97f1f5e30ee53a71ead6fdbba6b964.svg";